var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.tile)?_c('div',{ref:"templateContainer",staticClass:"tile-main-container",style:(_vm.tileStyle)},[(!_vm.isLoading)?_vm._l((_vm.widgets || []),function(widget){return _c('TemplateLayer',{key:widget.assoc_id,attrs:{"widget":widget}})}):_c('div',{staticClass:"loader"},[_c('div',{staticClass:"loader-background"},[_c('Loader')],1)])],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }